import { openBigCompanyAlert } from "@/components/AuthSubject/ErrDialog";
import requestGd from "../utils/requestGaoding";

export function updateCert({ id, subject }) {
  return requestGd({
    method: "put",
    url: `/trade/material-vip-certs/${id}`,
    data: {
      address: subject.address,
      authorized_id: subject.id_no,
      authorized_name: subject.name,
      phone: subject.phone,
      authorized_type: subject.type,
    },
  }).then((res) => {
    // https://yapi.gaoding.com/project/1919/interface/api/202227
    //  "code": "12021001",
    // "message": "授权信息提交失败，不允许填写大企业授权主体名称"
    if (res.err && res.data.code === "12021001") {
      openBigCompanyAlert();
    }
    return res;
  });
}

//"WAIT_EFFECTIVE" | "EFFECTIVE" | "NONEFFECTIVE";
const CertStatusEnum = {
  WAIT_EFFECTIVE: 1,
  EFFECTIVE: 1,
  NONEFFECTIVE: 0,
};

//"WAIT_EFFECTIVE" | "EFFECTIVE" | "NONEFFECTIVE";
export const VipCertStatusEnum = {
  WAIT_EFFECTIVE: "WAIT_EFFECTIVE",
  EFFECTIVE: "EFFECTIVE",
  NONEFFECTIVE: "EFFECTIVE",
};

/**
 * 将稿定的主体转换成花瓣兼容的主体
 * @param {GDCertSubject | GDCertSubject[]} data
 * @returns {CERTSubject | CERTSubject[]}
 */
export function gaodingCertToHuabanCert(data) {
  if (Array.isArray(data)) {
    return data.map((item) => gaodingCertToHuabanCert(item));
  }

  if (!data) {
    return {};
  }

  return {
    id: data.id,
    user_id: data.org_id,
    uuic_id: data.org_id,
    source_type: 1,
    source_no: data.order_no,
    subject_id: data.authorized_id,
    subject_info: data.extra
      ? {
          name: data.extra.authorized_party,
          type: data.extra.authorized_type,
          email: data.extra.email,
          id_no: data.extra.id_card,
          phone: data.extra.phone,
          address: data.extra.address,
          phone_code: "",
        }
      : {},
    download_cnt: 0,
    valid_start_time: data.start_at,
    valid_end_time: data.end_at,
    valid: CertStatusEnum[data.cert_status_enum],
    cert_status_enum: data.cert_status_enum,
    org_id: data.org_id,
    data_type: 0,
    created_at: data.created_at,
    updated_at: data.updated_at,
  };
}

/**
 * 获取素材授权记录列表
 * https://yapi.gaoding.com/project/1919/interface/api/202057
 *
 * @param {{
 *  page_num?: number,
 *  page_size?: number,
 *  source_no?: string,
 *  valid?:  CERTSubject["valid"]
 * }} query
 * @returns {Promise<{list?: CERTSubject[], total: number, num: number, size: number}>}
 */
export function getCertList(query = {}) {
  return requestGd({
    method: "get",
    url: "/trade/material-vip-certs",
    query: {
      order_no: query.source_no,
      is_effective: query.valid,
      page_num: query.page_num,
      page_size: query.page_size,
    },
  }).then((res) => {
    return {
      list: gaodingCertToHuabanCert(res.data),
      ...res.pagination,
    };
  });
}
